(()=>{'use strict';
 document.querySelectorAll('[data-video-load]').forEach(posterButton=>{
  const player=posterButton.closest('.film-player'),video=player?.querySelector('video');
  if(!video)return;
  video.controls=false;
  video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');
  const controls=document.createElement('div');controls.className='film-controls';
  controls.setAttribute('role','group');controls.setAttribute('aria-label',video.getAttribute('aria-label')+' controls');
  controls.innerHTML='<div class="film-actions"><button type="button" data-film-toggle aria-label="Play video">Play</button><span class="film-time" aria-hidden="true">0:00 / –:–</span><button type="button" data-film-sound aria-label="Mute video">Sound off</button><button type="button" data-film-fullscreen aria-label="Open video full screen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M9 4H4v5m11-5h5v5M4 15v5h5m11-5v5h-5"/></svg></button></div><label class="film-seek"><span class="sr-only">Video position</span><input type="range" min="0" max="1000" value="0" step="1" disabled aria-label="Video position"></label><p class="film-status" role="status" aria-live="polite" hidden></p>';
  player.after(controls);
  const toggle=controls.querySelector('[data-film-toggle]'),sound=controls.querySelector('[data-film-sound]'),fullscreen=controls.querySelector('[data-film-fullscreen]'),seek=controls.querySelector('input'),clock=controls.querySelector('.film-time'),notice=controls.querySelector('.film-status');
  let attempt=0;
  function message(text){notice.textContent=text;notice.hidden=!text;}
  function timeLabel(value){if(!Number.isFinite(value))return '–:–';return Math.floor(value/60)+':'+String(Math.floor(value%60)).padStart(2,'0');}
  function updateTime(){
   const duration=video.duration,known=Number.isFinite(duration)&&duration>0;
   clock.textContent=timeLabel(video.currentTime||0)+' / '+timeLabel(duration);
   seek.disabled=!known;seek.value=known?String(Math.round(video.currentTime/duration*1000)):'0';
   seek.setAttribute('aria-valuetext',timeLabel(video.currentTime||0)+' of '+timeLabel(duration));
  }
  function updateButtons(){
   const stopped=video.paused||video.ended;
   toggle.textContent=video.ended?'Replay':stopped?'Play':'Pause';toggle.setAttribute('aria-label',video.ended?'Replay video':stopped?'Play video':'Pause video');
   sound.textContent=video.muted?'Sound on':'Sound off';sound.setAttribute('aria-label',video.muted?'Unmute video':'Mute video');
  }
  function activateSource(){
   if(video.hasAttribute('src'))return;
   const source=video.querySelector('source[data-src]');
   if(source){video.src=source.dataset.src;source.removeAttribute('data-src');}
  }
  function failed(error,id){
   if(id!==attempt||(!video.paused&&!video.error))return;
   if(error?.name==='AbortError'){message('');updateButtons();return;}
   posterButton.hidden=false;posterButton.querySelector('strong').textContent='Try again';
   message('The video could not start. Please try again.');updateButtons();
  }
  function startPlayback(){
   const id=++attempt;
   activateSource();
   if(video.error)video.load();
   if(video.ended)video.currentTime=0;
   posterButton.hidden=true;message('Loading video…');
   // Call play() during the original activation, without a metadata/canplay wait.
   const result=video.play();updateButtons();
   if(result?.catch)result.catch(error=>{
    if(id!==attempt||!video.paused)return;
    if(error.name==='NotAllowedError'&&!video.muted){
     // In-app browsers may only permit the initial playback without sound.
     video.muted=true;updateButtons();
     const fallback=video.play();if(fallback?.catch)fallback.catch(next=>failed(next,id));
    }else failed(error,id);
   });
  }
  function togglePlayback(){
   if(video.paused||video.ended)startPlayback();
   else{++attempt;video.pause();message('');updateButtons();}
  }
  posterButton.addEventListener('click',startPlayback);
  toggle.addEventListener('click',togglePlayback);
  video.addEventListener('click',()=>{if(!video.controls)togglePlayback();});
  sound.addEventListener('click',()=>{
   const wasPlaying=!video.paused;video.muted=!video.muted;updateButtons();
   if(wasPlaying&&!video.muted){const result=video.play();if(result?.catch)result.catch(error=>failed(error,attempt));}
  });
  seek.addEventListener('input',()=>{if(Number.isFinite(video.duration)){video.currentTime=Number(seek.value)/1000*video.duration;updateTime();}});
  ['loadedmetadata','durationchange','timeupdate','seeked'].forEach(event=>video.addEventListener(event,updateTime));
  video.addEventListener('playing',()=>{posterButton.hidden=true;message('');updateButtons();});
  video.addEventListener('waiting',()=>{if(!video.paused)message('Loading video…');});
  video.addEventListener('pause',()=>{message('');updateButtons();});
  video.addEventListener('volumechange',updateButtons);
  video.addEventListener('ended',()=>{message('');posterButton.hidden=false;posterButton.querySelector('strong').textContent='Replay video';updateButtons();});
  video.addEventListener('error',()=>failed(video.error,attempt));
  function restoreInlineControls(){video.controls=false;updateButtons();}
  video.addEventListener('webkitendfullscreen',restoreInlineControls);
  document.addEventListener('fullscreenchange',()=>{if(document.fullscreenElement!==video)restoreInlineControls();});
  if(!video.webkitEnterFullscreen&&!video.requestFullscreen)fullscreen.hidden=true;
  fullscreen.addEventListener('click',()=>{
   video.controls=true;
   try{
    if(video.webkitEnterFullscreen)video.webkitEnterFullscreen();
    else{const result=video.requestFullscreen();if(result?.catch)result.catch(restoreInlineControls);}
   }catch(error){restoreInlineControls();}
  });
  updateButtons();updateTime();
 });
})();
